import App from '../App';
import { KompanSettingsManagerState } from '../managers/KompanSettingsManager';

import { AppModule } from '@egr/wcf/modules/core';
import { DataMap, DocumentInputContext, FileNotFoundError } from '@egr/wcf/modules/core/io';
import { isNullOrEmpty } from '@egr/wcf/modules/utils/string';

export class ProjectSettingsModule extends AppModule {
    public readonly moduleId: string = 'pCon.box.ProjectSettings';

    public constructor(protected app: App) {
        super();
    }

    public override async loadDocumentData(context: DocumentInputContext, data: DataMap): Promise<void> {
        if (data == null) {
            return Promise.resolve();
        }
        this.app.kompanSettingsManager.setKompanSettings(data as unknown as KompanSettingsManagerState);
        try {
            const floorPlanContentFileName: string = 'floor_plan.data';
            const floorPlan: string = await context.getResource(floorPlanContentFileName, false);
            if (!isNullOrEmpty(floorPlan)) {
                this.app.kompanSettingsManager.setFloorPlanData(floorPlan, false);
            }
        } catch (error) {
            // ignore file not found erro
            if (!(error instanceof FileNotFoundError)) {
                throw error;
            }
        }
        try {
            const floorPlanMapContentFileName: string = 'floor_plan_map.data';
            const floorPlanMap: string = await context.getResource(floorPlanMapContentFileName, false);
            if (!isNullOrEmpty(floorPlanMap)) {
                this.app.kompanSettingsManager.setFloorPlanData(floorPlanMap, true);
            }
        } catch (error) {
            // ignore file not found erro
            if (!(error instanceof FileNotFoundError)) {
                throw error;
            }
        }

        return Promise.resolve();
    }

    public override async saveDocumentData(): Promise<DataMap> {
        // can never happen
        return Promise.resolve({});
    }
}